/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Webhook_MethodInputs */

const cs_automation_webhook_method = /** @type {(inputs: Automation_Webhook_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const en_automation_webhook_method = /** @type {(inputs: Automation_Webhook_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Automation_Webhook_MethodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_webhook_method = /** @type {((inputs?: Automation_Webhook_MethodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Webhook_MethodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_webhook_method(inputs)
	return cs_automation_webhook_method(inputs)
});